import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=2fd7ee9a&scoped=true&"
import script from "./Verify.vue?vue&type=script&lang=js&"
export * from "./Verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd7ee9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd7ee9a')) {
      api.createRecord('2fd7ee9a', component.options)
    } else {
      api.reload('2fd7ee9a', component.options)
    }
    module.hot.accept("./Verify.vue?vue&type=template&id=2fd7ee9a&scoped=true&", function () {
      api.rerender('2fd7ee9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Verify.vue"
export default component.exports